import { WebsiteContentRouteEnum } from '~/router/@types';
import {
  MarqCommonEnumsSwWebsiteContentsTabEnum,
  MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest,
} from '~/swagger/data-contracts';

export const parseTabToStatus = (
  tab: WebsiteContentRouteEnum
): Pick<MonitoringWebsiteContentWebsiteContentCommonProtocolsGetWebsiteListRequest, 'tab'> => {
  switch (tab) {
    case WebsiteContentRouteEnum.Scanned:
      return {
        tab: MarqCommonEnumsSwWebsiteContentsTabEnum.Scanned,
      };
    case WebsiteContentRouteEnum.Flagged:
      return {
        tab: MarqCommonEnumsSwWebsiteContentsTabEnum.Detected,
      };
    case WebsiteContentRouteEnum.Requested:
      return {
        tab: MarqCommonEnumsSwWebsiteContentsTabEnum.Requested,
      };
    case WebsiteContentRouteEnum.Reported:
      return {
        tab: MarqCommonEnumsSwWebsiteContentsTabEnum.Reported,
      };
    case WebsiteContentRouteEnum.Removed:
      return {
        tab: MarqCommonEnumsSwWebsiteContentsTabEnum.Removed,
      };
    case WebsiteContentRouteEnum.Denied:
      return {
        tab: MarqCommonEnumsSwWebsiteContentsTabEnum.Denied,
      };
    case WebsiteContentRouteEnum.Dismissed:
      return {
        tab: MarqCommonEnumsSwWebsiteContentsTabEnum.Dismissed,
      };
    case WebsiteContentRouteEnum.TestPurchase:
      return {
        tab: MarqCommonEnumsSwWebsiteContentsTabEnum.Tp,
      };
    default:
      return {
        tab: MarqCommonEnumsSwWebsiteContentsTabEnum.Detected,
      };
  }
};
